import { render, staticRenderFns } from "./viewResponsibility.vue?vue&type=template&id=271ec25d&scoped=true&"
import script from "./viewResponsibility.vue?vue&type=script&lang=js&"
export * from "./viewResponsibility.vue?vue&type=script&lang=js&"
import style0 from "./viewResponsibility.vue?vue&type=style&index=0&id=271ec25d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271ec25d",
  null
  
)

export default component.exports